var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDAhuSignalHeatingCoil2 = function SvgDAhuSignalHeatingCoil2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684 480",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "341,54 682,54 682,462 592,462 592,460 680,460 680,56 341,56",
    fill: "#1C9D5B"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "594,460 592,460 592,423 586,423 586,421 594,421",
    fill: "#1C9D5B"
  }))));
};
export default SvgDAhuSignalHeatingCoil2;